module.exports = __webpack_public_path__ + "img/Type.561966ed.png";